// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bci_a bhi_a bhi_r bhi_j","ModeratorInvitationListItem__left":"bci_b bhi_a bhi_j","ModeratorInvitationListItem__note":"bci_c bhi_fm"};